module.exports = __webpack_public_path__ + "img/2022-04-25_20-15-53-640.9d482a86.jpg";